import { render, staticRenderFns } from "./OtherMenu.vue?vue&type=template&id=4fd1d1ee&scoped=true&"
import script from "./OtherMenu.vue?vue&type=script&lang=js&"
export * from "./OtherMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd1d1ee",
  null
  
)

export default component.exports